import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  search_icon,
  view_icon,
} from "../../../assets/imgs";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const SuperAdminCompanyRoles = () => {
  const navigate = useNavigate();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);

  const [owners, setOwners] = useState([]);
  const [search, setSearch] = useState("");

  const handleStatus = async (id) => {
    get(URL.ROLE_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getRoles("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleDelete = async () => {
    get(URL.DELETE_ROLE + popup)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          setPopup(false);
          getRoles("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getRoles = (search_) => {
    let formdata = new FormData();
    formdata.append("page", page);
    formdata.append("type", 4);
    formdata.append("search", search_);
    setSearch(search_);
    post(URL.KNF_ROLES_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          let finder = res?.lists?.filter(
            (i) => i?.code == "Knf-Company-Admin"
          );
          setOwners(finder);
          setPagination(res?.pagination_meta);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getRoles("");
  }, [page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Role",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (
                    givenpermissions?.includes(
                      "CAN-Status-KNF_ADMIN_COMPANY_ROLES"
                    )
                  ) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18 ${
                  row?.original?.code == "Knf-Company-Admin" ? "opacity-50" : ""
                }`}
                disabled={row?.original?.code == "Knf-Company-Admin"}
              >
                {value ? "Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {givenpermissions?.includes(
                  "CAN-View-KNF_ADMIN_COMPANY_ROLES"
                ) && (
                  <button
                    onClick={() => {
                      navigate("/superadmin-company-roles-view", {
                        state: { type: "view", id: row.original.id },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {/* {givenpermissions?.includes(
                  "CAN-Edit-KNF_ADMIN_COMPANY_ROLES"
                ) && (
                  <button
                    onClick={() => {
                      navigate("/superadmin-company-roles-view", {
                        state: { type: "edit", id: row.original.id },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}

                {givenpermissions?.includes(
                  "CAN-Delete-KNF_ADMIN_COMPANY_ROLES"
                ) && (
                  <button
                    onClick={() => setPopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          {/* Total:{pagination?.total ?? 0} */}
          Total:1
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => getRoles(e.target.value)}
              value={search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                No
              </button>
              <button
                onClick={() => {
                  handleDelete(false);
                }}
                className="back-btn f2 w-40"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperAdminCompanyRoles;
